// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu__btn[data-v-285b9088]{background:url(/images/menu-sc-ico.svg) no-repeat center 0;background-size:1.375rem;box-sizing:border-box;cursor:pointer;height:4.5rem;width:4.5rem}.menu__btn[data-v-285b9088]:hover{background-position:center -73px}@media only screen and (max-width:481px){.menu__btn[data-v-285b9088]{background-position:center -12px;height:3rem;width:3rem}.menu__btn[data-v-285b9088]:hover{background-position:center -85px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
